// import md5 from './md5.js';
// var md5 = require('./md5.min.js');
// console.log('md5',md5)
import { hex_md5 } from './md5.js';

var app_secret = "JAi7^uah1sY8737%5sJhs8*&sh$#sOIj";
var api_sign_fn = {
  make_sign(url, params) {
    var api_sign = '';
    var url_params = this.url_params(url);
    var request_params = [];
    if (url_params && url_params.length > 0) {
      request_params = Object.assign(url_params, params);
    } else {
      request_params = params;
    }
    if (request_params) {
      var keys = Object.keys(request_params).sort().reverse()
      var str = [];
      for (let key in keys) {
        str.push(keys[key] + "=" + request_params[keys[key]]);
      }
      var params_all = str.join("&")
      var sign_str = hex_md5(app_secret).toString() + params_all;
      console.log("拼接签名===", sign_str);
      api_sign = hex_md5(sign_str).toString();
      return api_sign;
    } else {
      return '';
    }
  },
get_make_sign_url(url, params) {
    var api_sign = "";
    var url_params = this.url_params(url);
    var request_params = [];
    if (url_params && url_params.length > 0) {
      request_params = Object.assign(url_params, params);
    } else {
      request_params = params;
    }
    if (request_params) {
      var keys = Object.keys(request_params)
        .sort()
        .reverse();
      var str = [];
      for (let key in keys) {
        str.push(keys[key] + "=" + request_params[keys[key]]);
      }
      var params_all = str.join("&");
      var sign_str = hex_md5(app_secret).toString() + params_all;
      console.log("hhhhh====", sign_str);
      return encodeURIComponent(sign_str);
    } else {
      return "";
    }
  },
  url_params(url) {
    var position = url.indexOf('?');
    if (position >= 0) {
      var params_str = url.substring(position + 1);
      var url_params = params_str.split("&");
      return url_params
    } else {
      return null;
    }
  }
}
// module.exports = api_sign;

export { api_sign_fn };


// WEBPACK FOOTER //
// ./src/utils/api_sign.js